import React from 'react';
import { useAttendanceNfc } from 'contexts/AttendanceNfcContext';
import { useNfcReader } from 'hooks/useNfcReader';

/**
 * Глобальная отметка NFC на любой странице CRM.
 * Ридер перехватывается в capture-фазе — UID не уходит в поля модалок и фильтров.
 */
export default function GlobalAttendanceNfcListener() {
  const { scanning, handleScan } = useAttendanceNfc();

  useNfcReader({
    enabled: !scanning,
    interceptWedge: true,
    onScan: handleScan,
  });

  return null;
}
